import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  connect() {
    $(".js-toast").fadeIn();

    setTimeout(function () {
      $(".js-toast").fadeOut();
    }, 6000);
  }

  close(e) {
    const toast = $(e.currentTarget).closest(".js-toast");

    toast.fadeOut();
  }
}
